export default __webpack_public_path__ + "static/media/login-logo.6479e96b.png";